<template>
  <div :class="['app-root', theme]">
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    theme() {
      return this.$store.getters.currentTheme
    }
  },
  watch: {
    theme: {
      immediate: true,
      handler(val) {
        document.documentElement.setAttribute('data-theme', val)
      }
    }
  }
}
</script>